const DEFAULT_CONFIG = {
    msPerBit: 1000,
    pxPerBit: 500,
    minBits: 1,
    maxBitsPerStroke: 100,
};
export function calculateStrokePixels(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let minX = Infinity, maxX = -Infinity;
    let minY = Infinity, maxY = -Infinity;
    for (const [x, y] of points) {
        minX = Math.min(minX, x);
        maxX = Math.max(maxX, x);
        minY = Math.min(minY, y);
        maxY = Math.max(maxY, y);
    }
    const width = (maxX - minX) * canvasWidth;
    const height = (maxY - minY) * canvasHeight;
    return Math.max(width * height, 1);
}
export function calculateStrokeLength(points, canvasWidth, canvasHeight) {
    if (points.length < 2)
        return 0;
    let length = 0;
    for (let i = 1; i < points.length; i++) {
        const [x1, y1] = points[i - 1];
        const [x2, y2] = points[i];
        const dx = (x2 - x1) * canvasWidth;
        const dy = (y2 - y1) * canvasHeight;
        length += Math.sqrt(dx * dx + dy * dy);
    }
    return length;
}
export function calculateBitsCost(stroke, canvasWidth = 1920, canvasHeight = 1080, config = DEFAULT_CONFIG, displayDurationMs = 30000) {
    const { pxPerBit, minBits, maxBitsPerStroke } = config;
    const area = calculateStrokePixels(stroke.points, canvasWidth, canvasHeight);
    const areaWithWidth = area + (stroke.width * stroke.width);
    const bitsByArea = Math.ceil(areaWithWidth / pxPerBit);
    const durationMultiplier = displayDurationMs / 30000;
    const rawBits = Math.ceil(bitsByArea * durationMultiplier);
    return Math.min(Math.max(rawBits, minBits), maxBitsPerStroke);
}
export function createPricingConfig(env) {
    return {
        msPerBit: parseInt(env.MS_PER_BIT || '') || DEFAULT_CONFIG.msPerBit,
        pxPerBit: parseInt(env.PX_PER_BIT || '') || DEFAULT_CONFIG.pxPerBit,
        minBits: parseInt(env.MIN_BITS || '') || DEFAULT_CONFIG.minBits,
        maxBitsPerStroke: parseInt(env.MAX_BITS_PER_STROKE || '') || DEFAULT_CONFIG.maxBitsPerStroke,
    };
}
export function formatBitsCost(bits) {
    return `${bits} Bit${bits !== 1 ? 's' : ''}`;
}
//# sourceMappingURL=pricing.js.map